import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { DireccionEstructuraFamiliarDTO } from 'src/app/core/models/bienestar/direccionEstructuraFamiliar-DTO';

const API_URL = environment.apiUrlBienestar;

@Injectable()
export class DireccionEstructuraFamiliarService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getDireccionEstructuraFamiliarService() {
        return this.http.get<BodyListResponse<DireccionEstructuraFamiliarDTO>>(
            API_URL + '/api/v1/direccionEstructuraFamiliar/todos'
        );
    }

    guardarDireccionEstructuraFamiliarService(bienestarDireccionEstructuraFamiliarDTO: DireccionEstructuraFamiliarDTO) {
        return this.http.post<DireccionEstructuraFamiliarDTO>(API_URL + '/api/v1/direccionEstructuraFamiliar', bienestarDireccionEstructuraFamiliarDTO);
    }

    getDireccionEstructuraFamiliarPorCodigoDireccionEstructuraFamiliarService(codigoDireccionEstructuraFamiliar: string) {
        return this.http.get<BodyResponse<DireccionEstructuraFamiliarDTO>>(
            API_URL + '/api/v1/direccionEstructuraFamiliar/' + codigoDireccionEstructuraFamiliar
        );
    }
}
